import { useState } from 'react'
import TaskCard from './TaskCard'

const TAG_ICONS = {
  Finance: '💰', Home: '🏠', Car: '🚗', Health: '❤️',
  Garden: '🌿', Admin: '📋', Shopping: '🛍️', Other: '📌',
}

function tagIcon(tag) { return TAG_ICONS[tag] ?? '📌' }

function TagGroup({ tag, tasks, onToggleDone, onDelete, onEvaluate, onEdit, namespace, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen)
  const done   = tasks.filter(t => t.done).length
  const active = tasks.length - done

  return (
    <section className="mb-2">
      <button
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center gap-2 px-1 py-2 text-left focus:outline-none"
        aria-expanded={open}
      >
        <span className="text-base">{tagIcon(tag)}</span>
        <span className="text-sm font-semibold text-gray-700">{tag}</span>
        <span className="ml-1 text-xs font-medium px-1.5 py-0.5 rounded-full bg-gray-100 text-gray-500">
          {active} left
        </span>
        {done > 0 && <span className="text-xs text-gray-400">{done} done</span>}
        <svg
          className={`ml-auto w-4 h-4 text-gray-400 transition-transform ${open ? '' : '-rotate-90'}`}
          fill="none" viewBox="0 0 16 16"
        >
          <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {open && (
        <div className="space-y-2 mt-1">
          {tasks.map(task => (
            <TaskCard
              key={task.id}
              task={task}
              onToggleDone={onToggleDone}
              onDelete={onDelete}
              onEvaluate={onEvaluate}
              onEdit={onEdit}
              namespace={namespace}
            />
          ))}
        </div>
      )}
    </section>
  )
}

export default function CategoryView({ tasks, onToggleDone, onDelete, onEvaluate, onEdit, namespace }) {
  const active = tasks.filter(t => !t.obsolete)

  const byTag = {}
  for (const task of active) {
    const key = task.tag ?? 'Other'
    if (!byTag[key]) byTag[key] = []
    byTag[key].push(task)
  }

  const sortedTags = Object.keys(byTag).sort((a, b) => {
    const aActive = byTag[a].filter(t => !t.done).length
    const bActive = byTag[b].filter(t => !t.done).length
    if (aActive !== bActive) return bActive - aActive
    return a.localeCompare(b)
  })

  return (
    <div className="space-y-1">
      {sortedTags.map(tag => (
        <TagGroup
          key={tag}
          tag={tag}
          tasks={byTag[tag]}
          onToggleDone={onToggleDone}
          onDelete={onDelete}
          onEvaluate={onEvaluate}
          onEdit={onEdit}
          namespace={namespace}
        />
      ))}

      {sortedTags.length === 0 && (
        <p className="text-sm text-gray-400 italic text-center py-12">No tasks yet. Add some above!</p>
      )}
    </div>
  )
}
